export default __webpack_public_path__ + "static/media/detail_mobile_16_7.0b6b1e1f.jpg";